@if (!allShows) {
  <app-spinner></app-spinner>
} @else {
  @if (showAll) {
    <h1>
      <a class="title-link standard" routerLink="/shows">
        Network Shows
      </a>
    </h1>
    @for (show of allShows; track show) {
      <a routerLink="/shows/{{show.slug || show.id}}">
        <i [responsiveBackgroundImage]="show.logo_square" [widthFactor]="0.1" [mobileWidthFactor]="0.1"></i>
        <span>{{show.name}}</span>
      </a>
    }
  } @else {
    @if (title) {
      <h1>
        <a class="title-link standard" routerLink="/shows">{{ title }}</a>
      </h1>
    }
    @for (show of popularShows; track show) {
      <a routerLink="/shows/{{show.slug || show.id}}">
        <i [responsiveBackgroundImage]="show.logo_square" [widthFactor]="0.1" [mobileWidthFactor]="0.1"></i>
        <span>{{show.name}}</span>
      </a>
    }
    <div>
      <a class="more-shows standard" routerLink="/shows">More</a>
    </div>
    <hr />
    @if (audioShows && audioShows.length > 0) {
      <h1>Podcast Network</h1>
      @for (show of audioShows; track show) {
        <a routerLink="/shows/{{show.slug || show.id}}">
          <i [responsiveBackgroundImage]="show.logo_square" [widthFactor]="0.1" [mobileWidthFactor]="0.1"></i>
          <span>{{show.name}}</span>
        </a>
      }
      <hr />
    }
    <h1>Articles</h1>
    @for (franchise of franchises; track franchise) {
      <a routerLink="/reports/franchise/{{franchise.identifier ?? franchise.id}}">
        <i [responsiveBackgroundImage]="franchise.square_logo || franchise.image" [widthFactor]="0.1"
        [mobileWidthFactor]="0.1"></i>
        <span>{{franchise.name}}</span>
      </a>
    }
  }
}